<template>
    <div class="pt-0 card-body p-0">
        <strong class="card-title mb-3">Client Details</strong>
        <hr />
        <form class="form-horizontal" @onsubmit.prevent action>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">Name</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Name" value v-model="name"
                            disabled />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="select-role" class="form-control-label">Date of birth</label>
                        <datepicker :input-class="'form-control'" :format="'dd-MM-yyyy'" v-model="dob"
                            @selected="birthDataSelect($event)"></datepicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">Mobile</label>
                        <input type="number" class="form-control" minlength="10" maxlength="10" placeholder="Mobile *"
                            v-model="mobile" disabled />
                        <!-- <div class="error">{{ validation.firstError('mobile') }}</div> -->
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('holding_type') }">
                        <label for="select-holding-type" class="form-control-label">Holding type</label>
                        <select id="select-holding-type" class="form-control" v-model="holding_type">
                            <option value>Select Holding Type</option>
                            <option v-for="(f, index) in holdingTypesData" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('holding_type') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('nominee_status') }">
                        <label for="select-holding-type" class="form-control-label">Nominee Status</label>
                        <select id="select-holding-type" class="form-control" v-model="nominee_status">
                            <option value>Select Nominee Status</option>
                            <option v-for="(f, index) in nomineeStatusData" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('nominee_status') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('kyc_status') }">
                        <label for="select-holding-type" class="form-control-label">KYC Status</label>
                        <select id="select-holding-type" class="form-control" v-model="kyc_status">
                            <option value>Select KYC Status</option>
                            <option v-for="(f, index) in kycStatusData" :value="f.id" :key="index + f.value">{{ f.value
                                }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('kyc_status') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('address') }">
                        <label class="form-control-label">Address</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Address" value
                            v-model="address" />
                        <div class="error">{{ validation.firstError('address') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('pan') }">
                        <label class="form-control-label">PAN</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="PAN" value v-model="pan" />
                        <div class="error">{{ validation.firstError('pan') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('gender') }">
                        <label for="select-holding-type" class="form-control-label">Gender</label>
                        <select id="select-holding-type" class="form-control" v-model="gender">
                            <option value>Select Gender</option>
                            <option v-for="(f, index) in genderOptions" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('gender') }}</div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">Email ID</label>
                        <input type="email" class="form-control" placeholder="Email ID" v-model="email" disabled />
                        <!-- <div class="error">{{ validation.firstError('email') }}</div> -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('tax_status') }">
                        <label for="select-holding-type" class="form-control-label">Tax Status</label>
                        <select id="select-holding-type" class="form-control" v-model="tax_status">
                            <option value>Select Tax Status</option>
                            <option v-for="(f, index) in taxStatusOptions" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('tax_status') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('tax_status_individual') }">
                        <label for="select-holding-type" class="form-control-label">Tax status (Individual)</label>
                        <select id="select-holding-type" class="form-control" v-model="tax_status_individual">
                            <option value>Select Tax Status (IND)</option>
                            <option v-for="(f, index) in taxStatusIndividualOptions" :value="f.id"
                                :key="index + f.value">{{
                                    f.value
                                }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('tax_status_individual') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('profile_status') }">
                        <label for="select-holding-type" class="form-control-label">Profile status</label>
                        <select id="select-holding-type" class="form-control" v-model="profile_status">
                            <option value>Select Profile Status</option>
                            <option v-for="(f, index) in profileStatusOptions" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('profile_status') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('work') }">
                        <label class="form-control-label">Work</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Work" value v-model="work" />
                        <div class="error">{{ validation.firstError('work') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('income') }">
                        <label class="form-control-label">Income</label>
                        <input type="number" class="form-control inmarginbtm" placeholder="Income" value
                            v-model="income" />
                        <div class="error">{{ validation.firstError('income') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('bank') }">
                        <label class="form-control-label">Bank</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Bank" value v-model="bank" />
                        <div class="error">{{ validation.firstError('bank') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-control-label">Risk profile</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Risk profile" value
                            v-model="risk_profile" disabled />
                        <!-- <div class="error">{{ validation.firstError('risk_profile') }}</div> -->
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('family') }">
                        <label class="form-control-label">Family</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Family" value
                            v-model="family" />
                        <div class="error">{{ validation.firstError('family') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('nominee') }">
                        <label class="form-control-label">Nominee</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Nominee" value
                            v-model="nominee" />
                        <div class="error">{{ validation.firstError('nominee') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('partner_name') }">
                        <label class="form-control-label">Partner Name</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Partner Name" value
                            v-model="partner_name" />
                        <div class="error">{{ validation.firstError('partner_name') }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('partner_code') }">
                        <label class="form-control-label">Partner Code</label>
                        <input type="text" class="form-control inmarginbtm" placeholder="Partner Code" value
                            v-model="partner_code" />
                        <div class="error">{{ validation.firstError('partner_code') }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': validation.hasError('action') }">
                        <label for="select-holding-type" class="form-control-label">Action</label>
                        <select id="select-holding-type" class="form-control" v-model="action">
                            <option value>Select Action</option>
                            <option v-for="(f, index) in actionOptions" :value="f.id" :key="index + f.value">{{
                                f.value
                            }}
                            </option>
                        </select>
                        <div class="error">{{ validation.firstError('action') }}</div>
                    </div>
                </div>
            </div>
            <div class="raw">
                <div class="col-md-12" v-if="errors && errors.length > 0">{{ errors }}</div>
            </div>
            <div class="form-group pull-left">
                <button type="button" @click="sendMailHandler" class="btn btn-primary"><i class="fa fa-envelope-o mr-2"
                        aria-hidden="true" />Send Mail</button>
            </div>
            <div class="form-group pull-right">
                <button type="button" @click="updateUserDetails" class="btn btn-info">{{ u_id === null ? "Create"
                    : "Update" }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
export default {
    // components: { PinCheck },
    // props: ["user"],
    components: { Datepicker },
    mixins: [commonMixins],
    created() {
        console.log("Client-Details: Created user:", this.user);
        console.log("Client-Details: Created params:", this.$route.params);
        if (this.$route.params.id) {
            this.user_id = parseInt(this.$route.params.id);
            this.getUserDetails();
        }
    },

    data() {
        return {
            registerDetails: {},
            user: "",
            _id: null,
            u_id: null,
            //-----------------
            record_id: "",
            user_id: "",
            name: "",
            dob: "",
            mobile: 0,
            holding_type: "",
            nominee_status: "",
            kyc_status: "",
            pan: "",
            address: "",
            gender: "",
            email: "",
            tax_status: "",
            tax_status_individual: "",
            profile_status: "",
            work: "",
            income: "",
            bank: "",
            risk_profile: "",
            family: "",
            nominee: "",
            partner_name: "",
            partner_code: "",
            action: "",
            //-----------------
            errors: [],
            submitted: false,
            holdingTypesData: [{ id: 0, value: "Single" }, { id: 1, value: "Joint" }, { id: 2, value: "Either" }, { id: 3, value: "Survivor" }],
            nomineeStatusData: [{ id: 0, value: "Verified" }, { id: 1, value: "Not Verified" }],
            kycStatusData: [{ id: 0, value: "Validated" }, { id: 1, value: "Not Validated" }],
            genderOptions: [{ id: 0, value: "Male" }, { id: 1, value: "Female" }],
            taxStatusOptions: [{ id: 0, value: "Individual" }, { id: 1, value: "Company" }, { id: 2, value: "Partnership" }, { id: 3, value: "etc" }],
            taxStatusIndividualOptions: [{ id: 0, value: "A resident and ordinarily resident (ROR)" }, { id: 1, value: "A resident but not ordinarily resident (RNOR)" }, { id: 2, value: "Non-Resident (NR)" }, { id: 3, value: "etc" }],
            profileStatusOptions: [{ id: 0, value: "Completed" }, { id: 1, value: "Pending" }],
            actionOptions: [{ id: 0, value: "Confirm" }, { id: 1, value: "Remove" }],
            showTrialExpiry: false
        };
    },
    validators: {
        name: function (value) {
            return Validator.value(value).required();
        },
        /* dob: function (value) {
            return Validator.value(value).required();
        }, */
        /* mobile: function (value) {
            return Validator.value(value)
                .required()
                .minLength(10)
                .maxLength(10);
        },
        holding_type: function (value) {
            return Validator.value(value).required();
        },
        nominee_status: function (value) {
            return Validator.value(value).required();
        },
        kyc_status: function (value) {
            return Validator.value(value).required();
        }, */
        /* pan: function (value) {
            return Validator.value(value).required();
        }, */
        /* address: function (value) {
            return Validator.value(value).required();
        }, 
        gender: function (value) {
            return Validator.value(value).required();
        },*/
        /* email: function (value) {
            return Validator.value(value)
                .required()
                .email();
        }, */

        /*
        tax_status: function (value) {
            return Validator.value(value).required();
        },
        tax_status_individual: function (value) {
            return Validator.value(value).required();
        },
        profile_status: function (value) {
            return Validator.value(value).required();
        },
         work: function (value) {
            return Validator.value(value).required();
        },
        income: function (value) {
            return Validator.value(value).required();
        },
        bank: function (value) {
            return Validator.value(value).required();
        },
        risk_profile: function (value) {
            return Validator.value(value).required();
        }, 
        family: function (value) {
            return Validator.value(value).required();
        },
        nominee: function (value) {
            return Validator.value(value).required();
        },
        partner_name: function (value) {
            return Validator.value(value).required();
        },
        partner_code: function (value) {
            return Validator.value(value).required();
        },
        */
        /*
        action: function (value) {
            return Validator.value(value).required();
        },
        firstname: function (value) {
            return Validator.value(value).required();
        },
        email: function (value) {
            return Validator.value(value)
                .required()
                .email();
        },
        mobile: function (value) {
            return Validator.value(value)
                .required()
                .minLength(10)
                .maxLength(10);
        },
        pin: function (value) {
            return Validator.value(value)
                .required()
                .minLength(4);
        },
        status: function (value) {
            return Validator.value(value).required();
        },
        role: function (value) {
            return Validator.value(value).required();
        },
        password: function (value) {
            return Validator.value(value)
                .required()
                .minLength(6);
        },
        "cpassword, password": function (cpassword, password) {
            if (this.submitted || this.validation.isTouched("cpassword")) {
                return Validator.value(cpassword)
                    .required()
                    .match(password);
            }
        } */
    },
    methods: {
        clearForm() {
            this.registerDetails = {};
            (this.name = ""),
                (this.dob = ""),
                (this.mobile = ""),
                (this.holding_type = ""),
                (this.nominee_status = ""),
                (this.kyc_status = ""),
                (this.pan = ""),
                (this.address = ""),
                (this.gender = ""),
                (this.email = ""),
                (this.tax_status = ""),
                (this.tax_status_individual = ""),
                (this.profile_status = ""),
                (this.work = ""),
                (this.income = ""),
                (this.bank = ""),
                (this.risk_profile = ""),
                (this.family = ""),
                (this.nominee = ""),
                (this.partner_name = ""),
                (this.partner_code = ""),
                (this.action = "");
        },
        sendMailHandler() {
            var _this = this;
            const params = { 'user_id': this.user_id };
            console.log('<< user_id >>', params)
            http.post("/frontend/send-email-client-details", params, function (
                error,
                response
            ) {
                if (!error) {
                    console.log("SEND MAIL RES: ", response);
                    if (response.responseType === "success") {
                        _this.$toastr.success(response.msg, "", {});
                    } else {
                        _this.errors = response.msg;
                    }
                } else {
                    console.log("error", error);
                }
            });
        },
        updateUserDetails() {
            var _this = this;
            this.submitted = true;

            this.$validate([]).then(success => {
                if (success == true) {
                    this.registerDetails = {
                        user_id: this.user_id,
                        name: this.name,
                        dob: this.getDate(this.dob),
                        mobile: this.mobile,
                        holding_type: this.holding_type !== "" ? this.holdingTypesData[this.holding_type].value : "",
                        nominee_status: this.nominee_status !== "" ? this.nomineeStatusData[this.nominee_status].value : "",
                        kyc_status: this.kyc_status !== "" ? this.kycStatusData[this.kyc_status].value : "",
                        pan: this.pan,
                        address: this.address,
                        gender: this.gender !== "" ? this.genderOptions[this.gender].value : "",
                        email: this.email,
                        tax_status: this.tax_status !== "" ? this.taxStatusOptions[this.tax_status].value : "",
                        tax_status_individual: this.tax_status_individual !== "" ? this.taxStatusIndividualOptions[this.tax_status_individual].value : "",
                        profile_status: this.profile_status !== "" ? this.profileStatusOptions[this.profile_status].value : "",
                        work: this.work,
                        income: this.income,
                        bank: this.bank,
                        risk_profile: this.risk_profile,
                        family: this.family,
                        nominee: this.nominee,
                        partner_name: this.partner_name,
                        partner_code: this.partner_code,
                        action: this.action !== "" ? this.actionOptions[this.action].value : ""
                    };
                    if (this.u_id != null) {
                        this.registerDetails.record_id = this.u_id;
                    }
                    console.log('registerDetails >>>', this.registerDetails);
                    //return;
                    http.post("/frontend/client-details/update", this.registerDetails, function (
                        error,
                        response
                    ) {
                        if (!error) {
                            console.log("CREATE/UPDATE RES:", response);
                            if (response.responseType === "success") {
                                _this.$toastr.success(response.msg, "", {});
                                //_this.clearForm();
                                _this.$router.push({ name: "users" });
                            } else {
                                _this.errors = response.msg;
                            }
                        } else {
                            console.log("error", error);
                        }
                    });
                }
            });
        },
        setKeyWiseData(key, res) {
            if (key === "holding_type") {
                const holdingData = this.holdingTypesData.filter((item) => item.value === res[key]);
                return holdingData.length !== 0 ? holdingData[0].id : "";
            } else if (key === "nominee_status") {
                const nomineeData = this.nomineeStatusData.filter((item) => item.value === res[key]);
                return nomineeData.length !== 0 ? nomineeData[0].id : "";
            } else if (key === "kyc_status") {
                const kyc_statusData = this.kycStatusData.filter((item) => item.value === res[key]);
                return kyc_statusData.length !== 0 ? kyc_statusData[0].id : "";
            } else if (key === "gender") {
                const genderData = this.genderOptions.filter((item) => item.value === res[key]);
                return genderData.length !== 0 ? genderData[0].id : "";
            } else if (key === "tax_status") {
                const taxData = this.taxStatusOptions.filter((item) => item.value === res[key]);
                return taxData.length !== 0 ? taxData[0].id : "";
            } else if (key === "tax_status_individual") {
                const tax_status_individualData = this.taxStatusIndividualOptions.filter((item) => item.value === res[key]);
                return tax_status_individualData.length !== 0 ? tax_status_individualData[0].id : "";
            } else if (key === "profile_status") {
                const profileData = this.profileStatusOptions.filter((item) => item.value === res[key]);
                return profileData.length !== 0 ? profileData[0].id : "";
            } else if (key === "action") {
                const actionData = this.actionOptions.filter((item) => item.value === res[key]);
                return actionData.length !== 0 ? actionData[0].id : "";
            }
            return res[key];
        },
        getUserDetails() {
            var _this = this;
            //https://api.nobiasinvesting.com/frontend/client-details/get
            let param = {
                "user_id": String(_this.user_id)
            };

            http.post("frontend/client-details/get", param, (error, response) => {

                console.log('>>> response >>>', response);
                console.log('>>> error >>>', error);

                if (response.status === 'success') {
                    const res = response.data;
                    if (res === null) {
                        _this.u_id = null;
                        _this._id = null;
                    } else {
                        this.u_id = res._id;
                        for (let key in res) {
                            if (this.hasOwnProperty(key)) {
                                this[key] = this.setKeyWiseData(key, res);
                                //this[key] = res[key];
                            }
                        }
                    }
                }
            });
        },
        birthDataSelect(e) {
            console.log(e);
        }
    },
    watch: {
    }
};
</script>
<style scoped>
form .col-md-3 {
    width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/client-details.vue